module.exports = __webpack_public_path__ + "static/img/fondo-login.c4aa6af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fondo-login.jpg
// module id = iRSc
// module chunks = 3